'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { useTranslations } from 'next-intl';
import { useEffect, useRef } from 'react';
import { Carousel } from './Carousel';
import { MicroCombo } from './MicroCombo';
import { MiniCarousel } from './MiniCarousel';
import styles from './TrustpilotWidget.module.css';
import type { TrustBoxProps } from './TrustpilotWidget.types';
const TrustBox = t0 => {
  const $ = _c(10);
  const {
    isLeftAligned,
    templateId
  } = t0;
  const t = useTranslations("common");
  const ref = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      "5419b6ffb0d04a076446a9af": MicroCombo,
      "53aa8912dec7e10d38f59f36": Carousel,
      "539ad0ffdec7e10e686debd7": MiniCarousel
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const widgetComponent = t1;
  const Widget = widgetComponent[templateId];
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (typeof window === "undefined") {
        return;
      }
      if ((window as any).Trustpilot) {
        (window as any).Trustpilot.loadFromElement(ref.current, true);
      }
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== Widget || $[4] !== isLeftAligned || $[5] !== t) {
    t4 = isLeftAligned ? <div className={styles.alignmentWrapper}><div className={styles.alignmentContainer}><Widget ref={ref}><a href="https://uk.trustpilot.com/review/byway.travel" target="_blank" rel="noopener noreferrer" tabIndex={-1}>Trustpilot</a></Widget><p className="sr-only"><a href="https://uk.trustpilot.com/review/byway.travel" target="_blank" rel="noopener noreferrer">{t("trustpilot_reviews_link")}</a></p></div></div> : <><Widget ref={ref}><a href="https://uk.trustpilot.com/review/byway.travel" target="_blank" rel="noopener noreferrer" tabIndex={-1}>Trustpilot</a></Widget><p className="sr-only"><a href="https://uk.trustpilot.com/review/byway.travel" target="_blank" rel="noopener noreferrer">{t("trustpilot_reviews_link")}</a></p></>;
    $[3] = Widget;
    $[4] = isLeftAligned;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Script id="trustpilot" src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js" strategy="lazyOnload" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <>{t4}{t5}</>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export { TrustBox };